import React, { memo, useEffect } from "react";
import { formatVideoDuration, formatThousend } from "../../../utils/helper";
import ga from "@Lib/ga";
import qs from "qs";
import dayjs from "dayjs";

interface IProps {
  dataSource: any;
  dataSourceType?: string;
  index: number;
}

const Article: React.FC<IProps> = ({ dataSource, index, dataSourceType }) => {
  const { slug, title, thumb, author, startTime, views, playTime, type, description, id } = dataSource;
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const link = `${dataSource.link}${query.source && query.source !== ""
    ? `${dataSource.link.indexOf("?") === -1 ? "?" : "&"}source=${query.source}`
    : ""
    }${`${dataSource.link.indexOf("?") === -1 ? "?" : "&"}from=feature`}`;


  useEffect(() => {
    if (!thumb) return;

    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = thumb;
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [thumb]);

  return (
    <a
      id={dataSourceType !== "movie" ? "" : type === 3 ? "ContentMovies" : "ContentArticle"}
      className={`w-886 min-h-294 items-center flex mb-40 p-20 border-1 border-solid  ${type === 3 ? "bg-[#333333]" : "border-[#e8e8e8]"
        } ${index % 2 !== 0 ? "flex-row-reverse" : ""}`}
      href={link}
      target='_blank'
      data-id={id}
      onClick={() => {
        ga(["精華合輯", "合輯詳細頁", "文章"]);
      }}
    >
      <div
        className={`${type === 3 ? "w-383 h-214" : "w-383 h-252"}  relative ${index % 2 !== 0 ? "ml-50" : " mr-50"}`}
      >
        <picture>
          <source srcSet={thumb} type="image/jpeg" />
          <img
            src={thumb}
            className='block w-full h-full object-cover'
            alt={title}
            width={383}
            height={type === 3 ? 214 : 252}
            loading="eager"
            style={{ aspectRatio: `383/${type === 3 ? 214 : 252}` }}
            {...({ fetchPriority: "high" } as any)}
          />
        </picture>
        {!!playTime && (
          <span className='px-10 bg-black bg-opacity-50 rounded-tl-8 text-white font-semibold absolute bottom-0 right-0 h-22 leading-22'>
            {formatVideoDuration(playTime)}
          </span>
        )}
        {type === 3 && (
          <img
            src='https://photo.8891.com.tw/2023/10/09/1696843896847944.png'
            alt=''
            className='w-60 h-60 absolute left-0 bottom-0 right-0 top-0 m-auto'
            width="60"
            height="60"
            style={{ aspectRatio: "60/60" }}
          />
        )}
      </div>
      <div className='flex-1 relative min-h-252'>
        <h4 className={`text-18 text-[#333] font-bold leading-30 line-clamp-2 ${type === 3 && "text-[#fff]"}`}>
          {!!slug && <i className='py-1 px-10 bg-[#3264ff] text-[#fff] mr-14'>{slug}</i>}
          {title}
        </h4>
        <p className='text-[#999] leading-24 mt-20 h-120 line-clamp-5 text-14'>{description}</p>
        <div className='text-[#999] text-14 leading-16 absolute bottom-0 left-0'>
          <span className='mr-20'>{author}</span>
          <span className='mr-20'>{dayjs(startTime).format("YYYY-MM-DD")}</span>
          <span className='mr-20'>{type === 3 ? `${formatThousend(views)}瀏覽` : `閱讀${formatThousend(views)}`}</span>
        </div>
      </div>
    </a>
  );
};

export default memo(Article);
